module.exports = __webpack_public_path__ + "media/ringtones-kill-bill-whistle.4edd0c7d.mp3";